import { Add } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';

export function AddItemFooter() {
  const { t } = useTranslation();
  return (
    <div
      className="flex w-full items-center gap-1 px-1.5 py-1 text-xs font-normal leading-4 text-text-neutral-secondary"
      aria-hidden="true"
    >
      <Add size={24} />
      <span>{t(($) => $.views.visualization.addItem.label)}</span>
    </div>
  );
}
